import { useState, useEffect, useRef } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./WhyChooseUs.css";

import whyChooseData from "../../data/whyChooseData";
import whyChooseCarouselData from "../../data/whyChooseCarouselData";

const WhyChooseUs = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  // ==========================
  // NEXT
  // ==========================

  const nextSlide = () => {
    setCurrentSlide((prev) =>
      prev === whyChooseCarouselData.length - 1 ? 0 : prev + 1,
    );
  };

  // ==========================
  // PREVIOUS
  // ==========================

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? whyChooseCarouselData.length - 1 : prev - 1,
    );
  };

  // ==========================
  // AUTO SLIDE
  // ==========================

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentSlide, isPaused]);

  // ==========================
  // KEYBOARD SUPPORT
  // ==========================

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowRight") {
        nextSlide();
      }

      if (e.key === "ArrowLeft") {
        prevSlide();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  // ==========================
  // TOUCH EVENTS
  // ==========================

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const distance = touchStartX.current - touchEndX.current;

    if (distance > 60) {
      nextSlide();
    }

    if (distance < -60) {
      prevSlide();
    }
  };

  return (
    <section className="why-choose">
      {/* =========================
      TOP HEADING
  ========================== */}

      <div className="why-top">
        <span className="section3-tag">WHY CHOOSE US</span>

        <h2>
          Building Sports Infrastructure
          <br />
          With Quality & Trust
        </h2>

        <p className="why-description">
          We specialize in designing and constructing premium sports
          infrastructure using certified materials, skilled professionals, and
          international construction standards.
        </p>
      </div>

      {/* =========================
      IMAGE + CARDS
  ========================== */}

      <div className="why-container">
        {/* LEFT SIDE */}
        <div className="why-left">
          <div
            className="why-image"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
          >
            <img
              key={currentSlide}
              src={whyChooseCarouselData[currentSlide].image}
              alt={whyChooseCarouselData[currentSlide].title}
              className="why-carousel-image"
            />

            <div className="carousel-overlay">
              <h3>{whyChooseCarouselData[currentSlide].title}</h3>
              <p>{whyChooseCarouselData[currentSlide].location}</p>
              <span>{whyChooseCarouselData[currentSlide].surface}</span>
            </div>

            <button className="carousel-arrow left" onClick={prevSlide}>
              <FaChevronLeft />
            </button>

            <button className="carousel-arrow right" onClick={nextSlide}>
              <FaChevronRight />
            </button>

            <div className="carousel-dots">
              {whyChooseCarouselData.map((_, index) => (
                <span
                  key={index}
                  className={currentSlide === index ? "dot active" : "dot"}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>

            <div className="experience-badge">
              <h2>15+</h2>
              <span>
                Years of
                <br />
                Experience
              </span>
            </div>

            <div className="project-badge1">
              <h3>5500+</h3>
              <p>Projects Completed</p>
            </div>
          </div>

          {/* Button below image */}
          <div className="why-btn-wrapper">
            <Link to="/contact" className="why-btn">
              Get Free Consultation →
            </Link>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="why-content">
          <div className="why-grid">
            {whyChooseData.map((item) => (
              <div className="why-card" key={item.id}>
                <div className="why-icon1">
                  <item.icon />
                </div>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
